* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.separator {
  display: block;
  padding: 0 calc(var(--spacer) / 2);
}

.mitre-container {
  height: 30px;
}

gz-labeled-content::part(label) {
  padding-top: var(--spacer);
}

gz-labeled-content::part(content) {
  color: var(--main-titles-inputs-600);
}

.section-title {
  color: var(--chart-300-icon-buttons);
}

.counter {
  padding-left: calc(var(--spacer) / 2);
  color: var(--chart-300-icon-buttons);
}

a.hydragrid-edit-link {
  color: var(--blue-layout-400-primary);
  &:hover {
    color: var(--blue-layout-301-active);
  }
}
